export const BASE_URL = process.env.BASE_URL;
export const LS_BASKET_LAST_UPDATE = "basket-last-update";
export const LS_BASKET = "ms-basket";
export const API_URL = process.env.API_URL;
export const CLIENT_TOKEN = process.env.CLIENT_TOKEN;
export const CLUB_ID = process.env.CLUB_ID;
export const RESAMANIA_NETWORK_NODE_ID = process.env.RESAMANIA_NETWORK_NODE_ID;

export const MONSTADE_CHECKOUT_ID = process.env.MONSTADE_CHECKOUT_ID;
export const CLUB_CODE = process.env.CLUB_CODE;
export const DEFAULT_HEADERS = {
  "X-User-Network-Node-Id": RESAMANIA_NETWORK_NODE_ID,
  "X-User-Club-Id": CLUB_ID,
  "Content-Type": "application/ld+json",
};

export const CLIENT_ID = process.env.CLIENT_ID;
export const CLIENT_SECRET = process.env.CLIENT_SECRET;
export const CONTACT_USER_ENDPOINT = "contact_users/";
export const CONTACT_ENDPOINT = "contacts/";

export const FREE_TRAINING_ACTIVITY = process.env.FREE_TRAINING_ACTIVITY;
export const PERSONAL_TRAINING_SOLO_ACTIVITY =
  process.env.PERSONAL_TRAINING_SOLO_ACTIVITY;
export const PERSONAL_TRAINING_GROUP_ACTIVITY =
  process.env.PERSONAL_TRAINING_GROUP_ACTIVITY;
export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const JWT_EXPIRED_MESSAGE = "Jwt Expired";

export const activitiesNotIncludedInClassEvents = [
  PERSONAL_TRAINING_SOLO_ACTIVITY,
  FREE_TRAINING_ACTIVITY,
  PERSONAL_TRAINING_GROUP_ACTIVITY,
];
// Server Laravel
export const LOCAL_API = process.env.LOCAL_API;

export const SINGLE_SESSION_PRODUCT_ID = process.env.SINGLE_SESSION_PRODUCT_ID;
export const SINGLE_VISIO_SESSION_PRODUCT_ID =
  process.env.SINGLE_VISIO_SESSION_PRODUCT_ID;

// Common
export const LOADING_MESSAGE = "Chargement...";
// Planning

//String for checking time range
export const timeRanges = {
  MORNING: "MORNING",
  NOON: "NOON",
  AFTERNOON: "AFTERNOON",
  EVENING: "EVENING",
};
// Time Range Labels
export const timeRangeLabels = {
  MORNING_LABEL: "Matin",
  NOON_LABEL: "Midi",
  AFTERNOON_LABEL: "Après midi",
  EVENING_LABEL: "Soir",
};
export const CONFIRMED_SIGNUP_CLASS = "Inscription validée";
export const CONFIRMED_QUEUE_CLASS =
  "Inscription à la file d'attente prise en compte";
export const CONFIRMED_CANCELATION_CLASS = "Annulation prise en compte";
export const SELECT_DAY_PLANNING_MESSAGE =
  "Sélectionnez un jour pour voir les créneaux disponibles";
export const NO_CLASS_TODAY = "Pas de cours ce jour";

// errors
export const ALREADY_ATTENDING_ERROR = "api.error.attendee.already-attending";
export const ALREADY_ATTENDING_ERROR_MESSAGE =
  "Vous participez déjà à ce cours.";

export const UNAUTHORIZED_ENDPOINT_ERROR =
  "api.error.scope.unauthorized-endpoint";
export const UNAUTHORIZED_ENDPOINT_ERROR_MESSAGE = "Opération impossible";

export const EVENT_IN_THE_PAST_ERROR = "api.error.attendee.event-in-the-past";
export const EVENT_IN_THE_PAST_ERROR_MESSAGE = "Le cours a déjà eu lieu";

export const ATTENDEE_NO_UNIT_ERROR = "api.error.attendee.no-units";
export const ATTENDEE_NO_VALID_COUNTER_CREDIT_ERROR =
  "api.error.attendee.no-valid-counter-credit";
export const ATTENDEE_NO_UNIT_ERROR_MESSAGE =
  "Vous n'avez pas de crédit qui corresponde à cet événement.";

export const ATTENDEE_LIMIT_REACHED = "api.error.attendee.limit-reached";
export const ATTENDEE_LIMIT_REACHED_MESSAGE =
  "La réservation n'est plus possible pour ce cours";

export const ATTENDEE_NO_VALID_TAG = "api.error.attendee.no-valid-tag";
export const ATTENDEE_NO_VALID_TAG_MESSAGE =
  "Vous n'avez pas d’abonnement qui corresponde à cet événement.";

export const ATTENDEE_NO_TAG = "api.error.attendee.no-tags";
export const ATTENDEE_NO_TAG_MESSAGE =
  "Vous n'avez pas d’abonnement qui corresponde à cet événement.";

export const ATTENDEE_NO_TAG_OR_COUNTER = "api.error.attendee.tags-or-counters";
export const ATTENDEE_NO_TAG_OR_COUNTER_MESSAGE =
  "Vous n'avez pas d’abonnement ou de crédit qui correspondent à cet événement.";

export const ATTENDEE_ANTICIPATION = "api.error.attendee.anticipation";
export const ATTENDEE_ANTICIPATION_MESSAGE =
  "Le délai d’anticipation n’est pas respecté.";

// On dirait que c'est l'erreur pour quand trop d'inscriptions par jour
export const ATTENDEE_LIMIT = "api.error.attendee.limit";
export const ATTENDEE_LIMIT_MESSAGE =
  "Vous ne pouvez réserver que 2 évenements par jour.";

export const INVALID_GRANT_ERROR = "invalid_grant";
export const REFRESH_TOKEN_EXPIRED_ERROR_DESCRIPTION =
  "Refresh token has expired";
export const REFRESH_TOKEN_EXPIRED_ERROR = "refresh_token_expired";

export const ATTENDEE_NO_VALID_COUNTER_TYPE =
  "api.error.attendee.no-valid-counter-type";
export const ATTENDEE_NO_VALID_COUNTER_TYPE_MESSAGE =
  "Vous n'avez pas de crédit qui corresponde à cet événement.";

export const ATTENDEE_NO_VALID_COUNTER_CREDIT = "api.error.attendee.delay-exceed";
export const ATTENDEE_NO_VALID_COUNTER_CREDIT_MESSAGE = "Vous n’avez plus de crédit, merci de contacter l’accueil.";

export const QUEUE_FULL_ERROR = "api.error.attendee.queue-limit-reached";
export const QUEUE_FULL_ERROR_MESSAGE = "La liste d’attente est complète.";

// Links
export const MY_ACCOUNT_LINK = BASE_URL + process.env.MY_ACCOUNT_PAGE_LINK;
export const CHECKOUT_LINK = BASE_URL + "paiement";
export const BASKET_PAGE_LINK = BASE_URL + "panier";
export const FORGOT_PASSWORD_LINK =
  API_URL +
  "monstade/oauth/password-lost?client_id=" +
  CLIENT_ID +
  "&redirect_uri=" +
  BASE_URL +
  "&response_type=code";

// Form Validation
export const INVALID_EMAIL_MESSAGE =
  "Veuillez saisir une addresse email valide.";
export const REQUIRED_EMAIL_MESSAGE = "Une adresse email est requise.";
export const INPUT_TOO_SHORT = "Le texte saisi est trop court.";
export const INPUT_TOO_LONG = "Le texte saisi est trop long.";
export const REQUIRED_FIELD = "Ce champ est requis.";
export const PHONE_NUMBER_LENGTH_MESSAGE =
  "Le numéro de téléphone n'est pas valide";
// export const phoneRegExp = /^(0|\+[0-9]{2})[1-9]([-. ]?[0-9]{2}){4}$/
export const phoneRegExp = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
export const MIN_AGE_MESSAGE = "Vous devez être agé(e) d'au moins 16 ans.";
export const MAX_AGE_MESSAGE =
  "Ce n'est pas sérieux de faire du sport à votre age...";
export const EMAIL_ALREADY_USED_ERROR_CODE =
  "api.error.contact.email-already-used";
export const EMAIL_ALREADY_USED_MESSAGE =
  "Cette adresse email est déjà utilisée.";
export const SIGNUP_SUCCESS_MESSAGE = `Bienvenue à MON STADE ! Votre souscription à un de nos services a été validée, et votre compte est créé. 
Vous allez à présent recevoir un e-mail de la part du logiciel RESAMANIA : merci de rester attentif à sa réception dans votre boîte aux lettres. Grâce à lui vous pourrez définir votre mot de passe et accéder à votre espace personnel sécurisé. 
Contactez-nous en cas de problème au 01 44 23 30 00.`;
export const PASSWORD_CONFIRM_REQUIRED = "Confirmez votre mot de passe.";
export const PASSWORDS_NOT_EQUAL =
  "Les mots de passe saisis ne correspondent pas.";
export const CONTACT_DETAILS_UPDATED = "Vos coordonnées ont été mises à jour.";
export const PASSWORD_UPDATED = "Votre mot de passe a été mis à jour.";
export const WRONG_PASSWORD = "Votre mot de passe actuel ne correspond pas.";

export const ERROR_OCCURED = "Une erreur s'est produite.";
export const VALUE_ALREADY_USED_API = "Cette valeur est déjà utilisée."; // Valeur renvoyée par l'Api, ne pas modifier car utiliser pour le déclenchement de message d'erreurs
export const IS_NOT_A_VALID_POSTCODE = "is not a valid postal code";
export const INVALID_POSTCODE_MESSAGE = "Le code postal est invalide.";

// Programmes personnalisés - Custom Programs
export const CUSTOM_PROGRAM_POPUP_TITLE =
  "mon programme 100% personnalisé en 4 étapes";
export const CUSTOM_PROGRAM_STEP_ONE_TITLE = {
  title: "mon bilan de condition physique initial",
  subtitle: "",
};
export const CUSTOM_PROGRAM_STEP_TWO_TITLE = {
  title: "mon Plan d'entraînement",
  subtitle:
    "Le préparateur physique complète l'analyse de mon profil au cours d'une consultation, puis il conçoit mon plan d'entraînement.",
  button: "2/ Mon plan d'entraînement",
};
export const CUSTOM_PROGRAM_STEP_THREE_TITLE = {
  title: "mon Mode d'entraînement",
  subtitle:
    "Les séances de mon Plan d'entraînement peuvent être encadrées par un Préparateur physique dans le cadre du Personal Training. Il s'agit de séances éducatives de 1h encadrées par le Préparateur physique, qui assurera également le suivi et les éventuelles adaptations du Plan.",
  button: "3/ Mon Entraînement",
};
export const CUSTOM_PROGRAM_STEP_FOUR_TITLE = {
  title: "En option : choisir des tests pour suivre mes progrès",
  subtitle:
    "Les tests médicaux et sportifs de mon stade lab peuvent être réalisés à tout moment du Programme pour évaluer ses progrès.",
  button: "4/ Mes Tests de suivi",
};

export const STEP_ONE_NEXT_STEP_MESSAGE =
  "Veuillez sélectionner un bilan avant de continuer";
export const STEP_TWO_NEXT_STEP_MESSAGE =
  "Veuillez sélectionner un plan d'entrainement avant de continuer";
export const STEP_THREE_NEXT_STEP_MESSAGE =
  "Veuillez définir un mode d'entrainement avant de continuer";

// export const LIST_OF_BILANS = [
//    {id: 2271,name: "BILANS APA" }, {id: 2272,name: "BILAN FIT" },
//    {id: 2347,name: "BILAN FIT-VO2" }, {id: 2348 , name: "BILAN MUSCULAIRE / Objectif Préparation physique" },
//    {id: 2349,name: "BILAN MUSCULAIRE /Objectif Posture" }, {id: 2350 , name: "BILAN Med-APA" },
//    {id: 2351,name: "BILAN RUN" }, {id: 2352 , name: "BILAN RUN-VO2" },
//    {id: 2353,name: "BILAN TRIATHLON" },

// ];

export const BILAN_COUNTER_UNIT = "BILANS MEDICAUX";

export const PLANS_ENTRAINEMENT_PRODUCT_IDS =
  process.env.PLANS_ENTRAINEMENT_PRODUCT_IDS;
export const COURS_COLLECTIFS_PRODUCT_IDS =
  process.env.COURS_COLLECTIFS_PRODUCT_IDS;
export const TESTS_PRODUCT_IDS = process.env.TESTS_PRODUCT_IDS;
export const FREE_TRAINING_PRODUCT_IDS = process.env.FREE_TRAINING_PRODUCT_IDS;
export const PERSONAL_TRAINING_PRODUCT_IDS =
  process.env.PERSONAL_TRAINING_PRODUCT_IDS;
export const BILANS_PRODUCT_IDS = process.env.BILANS_PRODUCT_IDS;
export const CGV_TRAINING_PRODUCTS_IDS = process.env.CGV_TRAINING_PRODUCTS_IDS;
export const CGV_PRODUCTS_IDS = process.env.CGV_PRODUCTS_IDS;
export const COURSCO_PRODUCT_IDS = process.env.COURSCO_PRODUCT_IDS;
export const VISIO_COURSCO_DISCOUNTED_PRODUCT_IDS =
  process.env.VISIO_COURSCO_DISCOUNTED_PRODUCT_IDS || [];
export const FREE_TRAINING_DISCOUNTED_PRODUCT_IDS =
  process.env.FREE_TRAINING_DISCOUNTED_PRODUCT_IDS || [];
export const BILANS_SESAMES_PRODUCT_IDS = process.env.BILANS_SESAMES_PRODUCT_IDS;
